
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-support",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-support"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"i-support__circle",attrs:{"cx":"9","cy":"9","r":"6.15"}}),_c('g',{staticClass:"i-support__question"},[_c('path',{attrs:{"d":"M7.49 6.78A2 2 0 119 10v.83"}}),_c('path',{attrs:{"stroke-linecap":"square","stroke-miterlimit":"10","d":"M9 12.35v.04"}})])])
          )
        }
      }
    